<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.target') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.system') }}</dt>
        <dd class="d-table-cell sts-form-radio-mgt-0">
          <v-radio-group v-model="row" row dense hide-details>
            <v-radio :label="item.id" :value="item.id" v-show="!item.disabled" v-for="(item, index) in systemVm" :key="index"></v-radio>
          </v-radio-group>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  components: {},
  props: {
    itemStackType: String,
  },
  data() {
    return {
      row: null,
    };
  },
  computed: {
    ...mapState('analysis/statistics', ['userTargetSystems']),
    ...mapGetters('analysis/statistics', ['getIdTypes']),
    systemVm() {
      const systemData = [];
      const stackType = this.itemStackType || 'ABAP';
      if (this.itemStackType) {
        this.getIdTypes.map(el => {
          const item = {
            id: el.id,
            disabled: el.stackType !== stackType ? true : false,
          };
          systemData.push(item);
        });
      }
      return systemData;
    },
  },
  watch: {
    getIdTypes() {
      this.initDefault();
    },
    row() {
      this.emitEvent();
    },
    itemStackType() {
      this.initDefault();
    },
  },
  created() {
    this.fetchSystemType();
  },
  methods: {
    fetchSystemType() {
      this.$store.dispatch('analysis/statistics/targetSystems');
    },
    initDefault() {
      const filtered = this.getIdTypes.filter(el => el.stackType === this.itemStackType);
      this.row = filtered[0].id;
    },
    emitEvent() {
      const systemTargetValue = this.userTargetSystems.filter(el => el.id === this.row);
      this.$emit('changeTarget', systemTargetValue[0], 'target');
      // console.log('systemTarget', systemTargetValue[0]);
    },
  },
};
</script>
